import { RouteConfig } from 'vue-router';
const List = () => import('./views/list.vue');
const Read = () => import('./views/read.vue');
const routers: RouteConfig[] = [
    {
        path: 'list',
        name: 'list',
        component: List
    },
    {
        path: 'read',
        name: 'read',
        component: Read
    },
    {
        path: '*',
        redirect: 'list'
    },
];
export default routers;

